import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "../components/AppToast";

export default function SignUp() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    termsAccepted: false,
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async () => {
    const { name, email, password, confirmPassword, termsAccepted } = formData;

    if (!name || !email || !password || !confirmPassword) {
      return toast.error("All fields are required");
    }

    if (password !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    if (!termsAccepted) {
      return toast.error("You must accept the terms");
    }

    try {
      // const res = await apiService.post(API_URLS.signup, { name, email, password });
      // toast.success(res.message);
      navigate("/login");
    } catch (err) {
      toast.error("Signup failed");
    }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <h1 className="brand-logo">TRANGILE</h1>
        <h2>Build digital products with:</h2>
        <div className="feature">
          <h4>All-in-one tool</h4>
          <p>Amazing Features to make your life easier & work efficient</p>
        </div>
        <div className="feature">
          <h4>Easily add & manage your services</h4>
          <p>It brings together your tasks, projects, timelines, files and more</p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-box">
          <h2>Create account</h2>
          <p className="subtext">Free access to our dashboard.</p>

          <input
            type="text"
            name="name"
            placeholder="Full name"
            value={formData?.name}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Email address"
            value={formData?.email}
            onChange={handleChange}
          />

          <input
            type="password"
            name="password"
            placeholder="Password (8+ characters)"
            value={formData?.password}
            onChange={handleChange}
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm password"
            value={formData?.confirmPassword}
            onChange={handleChange}
          />

          <div className="terms">
            <input
              type="checkbox"
              name="termsAccepted"
              checked={formData?.termsAccepted}
              onChange={handleChange}
              id="termsAccepted"
            />
            <label htmlFor="termsAccepted">
              I accept the <a href="/" >Terms and Conditions</a>
            </label>
          </div>

          <button className="login-submit" onClick={handleSubmit}>SIGN UP</button>

          <p className="signup-link">
            Already have an account? <span onClick={() => navigate("/")}>Sign in here</span>
          </p>
        </div>
      </div>
    </div>
  );
}
